import { render, staticRenderFns } from "./BaseLegal.vue?vue&type=template&id=ea497c34&scoped=true&"
import script from "./BaseLegal.vue?vue&type=script&lang=js&"
export * from "./BaseLegal.vue?vue&type=script&lang=js&"
import style0 from "./BaseLegal.vue?vue&type=style&index=0&id=ea497c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea497c34",
  null
  
)

export default component.exports